module.exports = __webpack_public_path__ + "static/giantTube-8fcbb874654df2aafb12becd0876b72b.jpg";